import React, { useState, useEffect, useCallback } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import ReactPaginate from "react-paginate";
import NoData from "../../reusebale/noData";
import LeaseTableLoader from "../../skeleton-loader/lease-table";
import moment from "moment";
import {
  ArrowUpDown,
  ArrowDownUp,
  SquareX,
  SquareCheck,
  ArrowRight,
} from "lucide-react";
import db from "../../../db/index.json";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
const LandlordTable = ({ onViewDetails, searchTerm, filterByStatus }) => {
  const { landlord, rightPanel } = db;

  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [statusUpdating, setStatusUpdating] = useState(null);

  const [AllLandlord, setAllLandlord] = useState([]);
  const [filteredLandlords, setFilteredLandlords] = useState([]);
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllLandlord = useCallback(() => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    // Use different endpoint based on filterByStatus
    const endpoint =
      filterByStatus === "pending"
        ? `${BaseUrl}landlord/profile/getLandlordProfileByStatus/sendForApproval`
        : `${BaseUrl}landlord/profile/getAllLandlordProfiles?page=${currentPage}&limit=${itemsPerPage}`;

    fetch(endpoint, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success || result.status === "success") {
          let Data = result.data;
          for (const key in Data) {
            Data[key]["copmanyName"] =
              Data[key]?.companyInformation?.companyName;
          }
          setLoading(false);
          setAllLandlord(Data.filter((val) => val.approved === true));
          // Only set pagination data if not filtering by status
          if (!filterByStatus) {
            setTotalData(result.pagination?.totalLandlords || 0);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  }, [currentPage, itemsPerPage, loginSuccess?.token, filterByStatus]);

  useEffect(() => {
    GetAllLandlord();
  }, [GetAllLandlord]);

  // Filter landlords based on search term
  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredLandlords(AllLandlord);
    } else {
      const filtered = AllLandlord.filter((landlord) => {
        const firstName =
          landlord?.personalInformation?.firstName?.toLowerCase() || "";
        const lastName =
          landlord?.personalInformation?.lastName?.toLowerCase() || "";
        const fullName = `${firstName} ${lastName}`.toLowerCase();
        return fullName.includes(searchTerm.toLowerCase());
      });
      setFilteredLandlords(filtered);
    }
  }, [AllLandlord, searchTerm]);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleChangeStatus = (item) => {
    setStatusUpdating(item._id);
    const newApproved = !item.approved; // Toggle the approved status
    const newApprovedStatus = newApproved ? "accepted" : "rejected";
    const newStatus = newApproved ? "active" : "inactive";

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      recordId: item._id,
      status: newApprovedStatus,
      approved: newApproved,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/profile/landlordProfileDecision`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          // Update the local state to reflect the change
          setAllLandlord((prevLandlords) =>
            prevLandlords.map((landlord) =>
              landlord._id === item._id
                ? {
                    ...landlord,
                    status: newStatus,
                    approvedStatus: newApprovedStatus,
                    approved: newApproved,
                  }
                : landlord
            )
          );
          setStatusUpdating(null);
        } else {
          setStatusUpdating(null);
          alert(result.message || "Failed to update status");
        }
      })
      .catch((error) => {
        console.error(error);
        setStatusUpdating(null);
        alert("An error occurred while updating status");
      });
  };

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllLandlord].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllLandlord(sortedData);
    // The filtering will be reapplied automatically by the useEffect
  };

  return (
    <div className="h-full pt-5">
      <div className="bg-white w-full h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex items-center h-[12%]">
            <ParagraphTag
              content={landlord.tableHeading}
              classes="text-darkColor font-popinsSemiBold text-base pl-2"
            />
          </div>
          <div className="overflow-x-scroll w-full h-[88%] panelScroll pt-2">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[23%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={rightPanel.landlords}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "_id" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("_id")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("_id")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("_id")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[23%] pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={rightPanel.company}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "copmanyName" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("copmanyName")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("copmanyName")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("copmanyName")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={rightPanel.status}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "approvedStatus" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("approvedStatus")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("approvedStatus")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("approvedStatus")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={rightPanel.dueDate}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "createdAt" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("createdAt")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("createdAt")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("createdAt")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={rightPanel.phone}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                    </span>
                  </th>
                  <th className="w-[10%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={rightPanel.change}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[12%] text-right pr-4 pb-2">
                    <ParagraphTag
                      content={rightPanel.quick}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredLandlords.map((item, i) => (
                  <tr
                    key={i}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[25%] rounded-full">
                          <ImageTag
                            path={
                              item?.personalInformation?.profileImage?.url ||
                              "/assets/daashboard/landlord-color.png"
                            }
                            classes="w-[45px] h-[45px] rounded-full object-cover"
                            altText="logo"
                          />
                        </div>
                        <div className="w-[75%] cursor-pointer">
                          <ParagraphTag
                            content={`LID-${item?.landloardId?.slice(0, 10)}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={`${item?.personalInformation?.firstName} ${item?.personalInformation?.lastName}`}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[25%] rounded-full">
                          <ImageTag
                            path={
                              item?.companyInformation?.companyLogo?.url ||
                              "/assets/daashboard/company-info-Round.png"
                            }
                            classes="w-[45px] h-[45px] rounded-full object-cover"
                            altText="logo"
                          />
                        </div>
                        <div className="w-[75%] cursor-pointer">
                          <ParagraphTag
                            content="Company"
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={item?.companyInformation?.companyName}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-center items-center">
                        <span>
                          {(() => {
                            if (
                              item.approved &&
                              item.approvedStatus === "accepted"
                            ) {
                              return <SquareCheck color="#01CB78" size={20} />;
                            } else {
                              return <SquareX color="#E43B3B" size={20} />;
                            }
                          })()}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {moment(item?.createdAt).format("MM/DD/YYYY")}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.personalInformation?.phoneNumber}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                      <div className="flex justify-center">
                        <label className="inline-flex items-center cursor-pointer relative pl-3">
                          <input
                            checked={item.approved === true}
                            onChange={() => handleChangeStatus(item)}
                            disabled={statusUpdating === item._id}
                            type="checkbox"
                            className="sr-only peer"
                          />
                          <div
                            className={`relative w-11 h-6 bg-[#E43B3B38] peer-focus:outline-none rounded-full peer dark:bg-[#E43B3B38] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-[#0381CA] after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#0381CA] after:border-[#0381CA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-[#0381CA] peer-checked:bg-[#E43B3B38] ${
                              statusUpdating === item._id
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          ></div>
                          {statusUpdating === item._id && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
                            </div>
                          )}
                        </label>
                      </div>
                    </td>
                    <td className="pt-5 2xl:pt-4 px-4 flex justify-center items-center h-full">
                      <div
                        onClick={() => {
                          onViewDetails(item);
                        }}
                        className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                      >
                        <ArrowRight color="#6F6F6F" size={18} strokeWidth={2} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {loading && <LeaseTableLoader />}
            {!loading &&
              filteredLandlords.length === 0 &&
              AllLandlord.length > 0 && (
                <div className="w-full mt-5 text-center">
                  <p className="text-gray-500 font-popinsRegular">
                    No landlords found matching your search.
                  </p>
                </div>
              )}
            {AllLandlord.length === 0 && !loading && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center h-[13%]">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(totalData / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        />
      </div>
    </div>
  );
};

export default LandlordTable;
